import {__HERMES__} from './../../../config/api-config';
import {hermesSrpOfferApiConfig} from '../../../config/api-config';
import {defaultFlavour, defaultRoomString} from '../../../config/app-config';
import {parseDateIntoHermesString} from '../../../utils/date-utils';
import {ISrpConfig, ISrpData} from '../redux/types';

export const prepareSrpOfferApiRequest = ({
  // flavour = defaultFlavour,
  roomString = defaultRoomString,
  checkin,
  checkout,
  destination,
  pph,
  hotelId,
}) => {
  let cityId = '';
  const {_id: destinationCityId, xtr = {}, ct = {}} = destination;
  cityId = destinationCityId;

  if (xtr && xtr.flt) {
    const {_id: voyCityId} = ct;
    cityId = voyCityId;
  }

  const checkinDateForHermes = parseDateIntoHermesString(checkin.date);
  const checkoutDateForHermes = parseDateIntoHermesString(checkout.date);
  const pphString = `?pph=${encodeURIComponent(pph)}`;

  let url = `${__HERMES__}`;
  url += `/hotels/${hermesSrpOfferApiConfig.version}/offers/${defaultFlavour}/${cityId}/${checkinDateForHermes}/${checkoutDateForHermes}/${roomString}/${hotelId}`;
  url += `?pph=${pphString}`;

  return url;
};
